(ns iris.data.websocket-impl
  "WebSocket/Redis implementation of IDataSource protocol.
   
   This is a stub implementation that will be filled in during migration.
   For now, all methods throw 'not implemented' errors."
  (:require
   [iris.data.protocol :as proto]))

(defrecord WebSocketDataSource []
  proto/IDataSource

  ;; Raids
  (set-raid2eid [this abbr eid]
    (throw (js/Error. "WebSocket set-raid2eid not yet implemented")))
  
  (get-raid2eid [this abbr]
    (js/Promise.reject (js/Error. "WebSocket get-raid2eid not yet implemented")))
  
  (get-eid2raid [this eid]
    (js/Promise.reject (js/Error. "WebSocket get-eid2raid not yet implemented")))
  
  (reset-eid2raid [this]
    (throw (js/Error. "WebSocket reset-eid2raid not yet implemented")))
  
  (reset-raid2eid [this]
    (throw (js/Error. "WebSocket reset-raid2eid not yet implemented")))
  
  (reset-raid-cache-id [this]
    (throw (js/Error. "WebSocket reset-raid-cache-id not yet implemented")))
  
  ;; Votes
  (get-post-votes [this ws forum thread nick on-update-handler]
    (throw (js/Error. "WebSocket get-post-votes not yet implemented")))
  
  (get-post-votes-promise [this ws forum thread nick]
    (js/Promise.reject (js/Error. "WebSocket get-post-votes-promise not yet implemented")))
  
  ;; Replies
  (get-replies [this ws thread on-update-handler]
    (throw (js/Error. "WebSocket get-replies not yet implemented")))
  
  (get-replies-promise [this ws thread]
    (js/Promise.reject (js/Error. "WebSocket get-replies-promise not yet implemented")))
  
  (get-replies-t-promise [this ws thread]
    (js/Promise.reject (js/Error. "WebSocket get-replies-t-promise not yet implemented")))
  
  ;; Shares
  (get-shares-promise [this ws share-page-kind ruid]
    (js/Promise.reject (js/Error. "WebSocket get-shares-promise not yet implemented")))
  
  ;; Admin - Votes & Shares Logs
  (push-admin-votes-log [this data]
    (throw (js/Error. "WebSocket push-admin-votes-log not yet implemented")))
  
  (push-admin-shares-log [this data]
    (throw (js/Error. "WebSocket push-admin-shares-log not yet implemented")))
  
  ;; Thread Alerts
  (set-thread-follow [this data]
    (throw (js/Error. "WebSocket set-thread-follow not yet implemented")))
  
  (remove-thread-follow [this id]
    (throw (js/Error. "WebSocket remove-thread-follow not yet implemented")))
  
  (set-thread-follow-t [this id t]
    (throw (js/Error. "WebSocket set-thread-follow-t not yet implemented")))
  
  (get-thread-follow-promise [this id]
    (js/Promise.reject (js/Error. "WebSocket get-thread-follow-promise not yet implemented")))
  
  (get-all-thread-follow-promise [this uid]
    (js/Promise.reject (js/Error. "WebSocket get-all-thread-follow-promise not yet implemented")))
  
  ;; User Defaults
  (set-defaults-ws [this ws]
    (throw (js/Error. "WebSocket set-defaults-ws not yet implemented")))
  
  (get-defaults-ws-promise [this]
    (js/Promise.reject (js/Error. "WebSocket get-defaults-ws-promise not yet implemented")))
  
  (get-default-ws-with-fallback [this default]
    (js/Promise.reject (js/Error. "WebSocket get-default-ws-with-fallback not yet implemented")))
  
  ;; User Actions
  (set-last-action [this data]
    (throw (js/Error. "WebSocket set-last-action not yet implemented")))
  
  ;; Moderation Logs
  (push-admin-all-moderation-log [this data]
    (throw (js/Error. "WebSocket push-admin-all-moderation-log not yet implemented")))
  
  (push-admin-moderation-log [this data]
    (throw (js/Error. "WebSocket push-admin-moderation-log not yet implemented")))
  
  (get-admin-moderation-logs-promise [this ws uid]
    (js/Promise.reject (js/Error. "WebSocket get-admin-moderation-logs-promise not yet implemented")))
  
  (get-admin-all-moderation-logs-promise [this ws ruid]
    (js/Promise.reject (js/Error. "WebSocket get-admin-all-moderation-logs-promise not yet implemented"))))

(defn create-websocket-datasource
  "Create a new WebSocket data source (stub implementation)"
  []
  (->WebSocketDataSource))
